export default "https://cdn-shared.mathletics.com/teacher-modules/mx-portal/278/assets/images/icon_duplicate_email-836425a2ef959d9899b3ef23e0ff4796.svg";